import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import CompareLenderQuotes from "@/pages/tools/CompareLenderQuotes";

export const Route = createFileRoute("/tools/compare-lender-quotes")({
  head: () => seoHead("/tools/compare-lender-quotes"),
  component: CompareLenderQuotes,
});
